import { createSelector } from "@reduxjs/toolkit";
import { selectMapMoved } from "./select-map-moved";
import { selectMapZoomed } from "./select-map-zoomed";

export const selectUserInteractedWithMap = createSelector(
	[selectMapMoved, selectMapZoomed],
	(mapMoved, mapZoomed) => {
		return mapMoved || mapZoomed;
	},
);
